import React, { useEffect } from "react";
import { Wrapper } from "./Developers.styled";
import {
  Input,
  Row,
  Col,
  Button,
  SuccessNotification,
  ErrorNotification,
  Select_,
  Form,
  Spin,
  AutoComplete
} from "components/common";
import { callPostApi, callGetApi } from "utils/api";
import { useState } from "react";
import { getMeCallApiWithAuthOnly } from "utils/me";

const Developers = () => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  const [getAccessData, setGetAccessData] = useState([]);
  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
  const [accessPermission, setAccessPermission] = useState([]);
  const [isNewLoading, setIsNewLoading] = useState(false);
  const [isSubLoading, setIsSubLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [category, setCategory] = useState("");
  const [categoryPayload, setCategoryPayload] = useState("");
  const [accessDisplayName, setAccessDisplayName] = useState("");
  const [keyword, setKeyword] = useState("");
  const [access, setAccess] = useState("");
  const [subAccessDisplayName, setSubAccessDisplayName] = useState("");
  const [featureName, setfeatureName] = useState("");

  const handleCategoryChangeItem = (value) => {
    let find = categoryFilterOptions.find((op) => op.value.toLowerCase() === value.toLowerCase());
    if (find) {
      setCategory(find.value)
      setCategoryPayload(find.id)
    } else {
      setCategory(value)
    }
  }

  // create new Access
  const onFinish = (values) => {
    setIsNewLoading(true);
    const data = {
      category: category,
      categoryId: categoryPayload,
      displayName: accessDisplayName,
      keyword: keyword
    }
    callPostApi("/roles/access/feature", data, (data) => {
      SuccessNotification("Access Added");
      setIsNewLoading(false);
      form1.resetFields();
      setAccess(accessDisplayName);
      setCategory(''); setAccessDisplayName(''); setKeyword(''); setCategoryPayload('')
      getAccessApi();
      getMeCallApiWithAuthOnly();
      getCategorFilterOptionsApi();
      getAccessPermissionName();
    }, (err) => {
      setIsNewLoading(false);
      console.log(err);
    });
  };

  // create new subAccess
  const onSubFinish = (values) => {
    setIsSubLoading(true);
    let payload = {
      accessId: access,
      displayName: subAccessDisplayName,
      featureName: featureName,
      accessValue: 1,
    }
    if (payload.displayName && payload.featureName) {
      callPostApi("/roles/permission", payload, (data) => {
        SuccessNotification("SubAccess Added");

        getMeCallApiWithAuthOnly();
        setIsSubLoading(false);
        form.resetFields();
      }, (err) => {
        setIsSubLoading(false);
      });
    } else {
      ErrorNotification("Refresh the window, fields are invalid")
    }
  };

  // get all roles
  const getAccessApi = () => {
    setIsLoading(true);
    callGetApi("/roles", (data) => {
      setGetAccessData(data[0].access);
      setIsLoading(false);
    }, (err) => {
      console.log(err);
      setIsLoading(false);
    });
  };
  const getCategorFilterOptionsApi = () => {
    callGetApi("/roles/all/access", (data) => {
      let options = [];
      data.forEach((d) => {
        options.push({
          id: d._id,
          value: d.category
        })
      })
      setCategoryFilterOptions(options);
    }, (err) => {
      console.log(err);
    });
  };
  const getAccessPermissionName = () => {
    callGetApi("/roles/all/access/permission", (data) => {
      let options = [];
      data.forEach((d) => {
        options.push({
          id: d._id,
          name: d.displayName
        })
      })
      setAccessPermission(options);
    }, (err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    let word = `${category} ${accessDisplayName}`
    word = word.toLowerCase().replace(/\s+/g, '-');
    setKeyword(word);
    form1.setFieldValue('keyword', word);
  }, [category, accessDisplayName])

  useEffect(() => {
    getAccessApi();
    getCategorFilterOptionsApi();
    getAccessPermissionName();
  }, []);

  return (
    <Wrapper>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <Row gutter={[10, 10]}>
            <Col lg={12} xs={24} className="new-access-container">
              <Form
                form={form1}
                name="basic"
                autoComplete="off"
                onFinish={onFinish}
              >
                <div className="header-conatiner">
                  <h5>Create a New Access</h5>
                </div>

                <Row
                  gutter={[20, 20]}
                  style={{ padding: "0px 10px 20px 10px" }}
                >
                  <Col span={24}>
                    <Row gutter={[10, 10]}>
                      <Col lg={6} xs={7} md={4} className="label-col">
                        {" "}
                        <label>Category:</label>
                      </Col>
                      <Col lg={18} xs={17} md={20}>
                        <Form.Item
                          name="category"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter this Field! ",
                            },
                          ]}
                        >
                          <AutoComplete
                            className="input-container"
                            onChange={handleCategoryChangeItem}
                            options={categoryFilterOptions}
                            filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col lg={6} xs={7} md={4} className="label-col">
                        {" "}
                        <label>Display Name:</label>
                      </Col>
                      <Col lg={18} xs={17} md={20}>
                        <Form.Item
                          name="displayName"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter this Field!",
                            },
                          ]}
                        >
                          <Input
                            type="text"
                            value={accessDisplayName}
                            onChange={(e) => {
                              setAccessDisplayName(e.target.value);
                            }}
                            className="input-container"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col lg={6} xs={7} md={4} className="label-col">
                        {" "}
                        <label>Keyword:</label>
                      </Col>
                      <Col lg={18} xs={17} md={20}>
                        <Form.Item
                          name="keyword"
                        >
                          <Input
                            disabled
                            type="text"
                            value={keyword}
                            className="input-container"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Form.Item>
                      <Button
                        loading={isNewLoading}
                        title="Submit"
                        htmlType="submit"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>

            <Col lg={12} xs={24} className="sub-access-container">
              <Form
                name="basic"
                autoComplete="off"
                onFinish={onSubFinish}
                form={form}
              >
                <div className="header-conatiner">
                  <h5>Create a New Sub Access</h5>
                </div>
                <Row
                  gutter={[20, 20]}
                  style={{ padding: "0px 10px 20px 10px" }}
                >
                  <Col span={24}>
                    <Row gutter={[10, 10]}>
                      <Col lg={6} xs={7} md={4} className="label-col">
                        {" "}
                        <label>Access:</label>
                      </Col>
                      <Col lg={18} xs={17} md={20}>
                        <Form.Item
                          name="category"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter this Field!",
                            },
                          ]}
                        >
                          <Select_
                            options={accessPermission}
                            name
                            value={access}
                            onChange={(value) => {
                              setAccess(value);
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col lg={6} xs={7} md={4} className="label-col">
                        {" "}
                        <label>Display Name:</label>
                      </Col>
                      <Col lg={18} xs={17} md={20}>
                        <Form.Item
                          name="displayName"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter this Field!",
                            },
                          ]}
                        >
                          <Input
                            type="text"
                            value={subAccessDisplayName}
                            onChange={(e) => {
                              setSubAccessDisplayName(e.target.value);
                              let word = e.target.value.toLowerCase().replace(/\s+/g, '-');
                              setfeatureName(word);
                              form.setFieldValue('featureName', word);
                            }}
                            className="input-container"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col lg={6} xs={7} md={4} className="label-col">
                        {" "}
                        <label>Feature Name:</label>
                      </Col>
                      <Col lg={18} xs={17} md={20}>
                        <Form.Item
                          name="featureName"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter this Field!",
                            },
                          ]}
                        >
                          <Input
                            type="text"
                            value={featureName}
                            onChange={(e) => {
                              setfeatureName(e.target.value);
                            }}
                            className="input-container"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="submit">
                      <Button
                        loading={isSubLoading}
                        title="Submit"
                        htmlType="submit"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </>
      )}
    </Wrapper>
  );
};

export default Developers;
